import { gql } from '@apollo/client';

export const UPSERT_INDICATOR_PERIOD_DATE = gql`
  mutation upsertIndicatorPeriodDate($input: UpsertIndicatorPeriodDateInput!) {
    indicatorPeriodDate: upsertIndicatorPeriodDate(input: $input) {
      id
    }
  }
`;
